module.exports = __webpack_public_path__ + "img/adulto12.cc32e0df.jpg";